if (!customElements.get('card-color-selector')) {
  customElements.define(
    'card-color-selector',
    class CardColorSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.onColorChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onColorChange);
      }

      onColorChange = (event) => {
        const option = event.target.closest('input[data-variant-url]');
        if (!option) return;

        event.stopPropagation();

        const card = this.closest('.product-card-wrapper');
        if (!card) return;

        this.querySelectorAll('input[data-variant-url]').forEach((input) => {
          input.checked = input === option;
        });

        card.querySelectorAll('[data-card-variant-link]').forEach((link) => {
          link.href = option.dataset.variantUrl;
        });

        card.querySelectorAll('[data-product-url]').forEach((control) => {
          control.dataset.productUrl = option.dataset.variantUrl;
        });

        card.querySelectorAll('input.product-variant-id').forEach((input) => {
          input.value = option.dataset.variantId;
        });

        const primaryImage = card.querySelector('[data-card-primary-image]');
        if (primaryImage && option.dataset.imageSrc) {
          primaryImage.src = option.dataset.imageSrc;
          primaryImage.srcset = option.dataset.imageSrcset;
          primaryImage.alt = option.dataset.imageAlt;
          primaryImage.width = option.dataset.imageWidth;
          primaryImage.height = option.dataset.imageHeight;
        }

        const secondaryImage = card.querySelector('[data-card-secondary-image]');
        if (secondaryImage) secondaryImage.hidden = true;
      };
    },
  );
}
